// ═══════════════════════════════════════════════════════════════════════════════
//  src/dojo/useFeedback.js
//  EL DOJO — capa de retroalimentación instantánea
//
//  Dos recursos tomados de FLUENCY NEXUS, y los dos hacen el mismo trabajo:
//  confirmar el acierto ANTES de que el ojo llegue a leer nada.
//
//    · FLASH   — un destello radial verde o rojo sobre toda la pantalla.
//                Se percibe con visión periférica: el alumno ya sabe si acertó
//                aunque esté mirando el micrófono y no el marcador.
//    · FLOTANTE— el puntaje sube y se desvanece desde el centro. Es la señal
//                que convierte "sumé 20 puntos" en algo que se SIENTE.
//
//  Ambos son visuales puros: no bloquean, no esperan, no se pueden encolar mal.
//  Los sonidos viven en `dojoFx.js` y se disparan en paralelo — vista y oído
//  llegan juntos, que es de donde sale el golpe de dopamina.
// ═══════════════════════════════════════════════════════════════════════════════

import { useCallback, useEffect, useRef, useState } from 'react';

export function useFeedback() {
  const [flash, setFlash] = useState(null);      // 'go' | 'no' | null
  const [floats, setFloats] = useState([]);      // [{id, text, good}]
  const timers = useRef([]);
  const seq = useRef(0);

  // Todo temporizador pendiente muere con el componente: si el alumno sale a
  // media ronda, no debe quedar un setState apuntando a un árbol desmontado.
  useEffect(() => () => timers.current.forEach(clearTimeout), []);

  const track = (id) => { timers.current.push(id); };

  /**
   * Dispara el destello y, si se le pasa texto, el puntaje flotante.
   * @param {boolean} good
   * @param {string=} text  p.ej. "+20" o "−1"
   */
  const fire = useCallback((good, text) => {
    setFlash(good ? 'go' : 'no');
    track(setTimeout(() => setFlash(null), 230));

    if (!text) return;
    seq.current += 1;
    const id = seq.current;
    setFloats((f) => [...f, { id, text, good }]);
    track(setTimeout(() => setFloats((f) => f.filter((x) => x.id !== id)), 950));
  }, []);

  return { flash, floats, fire };
}
